import { tViews } from "../../../utils/table";
import { convertTimetoUnit } from "../utils/circuitsTableView";
import { defaultCellValue } from "../../../utils/enums";

// Report : Link SLA  - Circuits Table columns config

export const getReportTableColumns = () => {
  const tableColumns = [
    {
      prop: "circuit_display_name",
      get name() { return tViews('circuit.ctName'); } ,
      size: 250
    },
    {
      prop: "service_provider",
      get name() { return tViews('circuit.ctProvider'); } ,
      size: 250
    },
    {
      prop: "site_name",
      get name() { return tViews('circuit.ctSitesName'); } ,
      size: 200
    },
    {
      prop: "site_location",
      get name() { return tViews('circuit.ctLocation'); } ,
      size: 200
    },

    {
      prop: "loss",
      get name() { return tViews('circuit.ctLoss'); } ,
      size: 141
    },
    {
      prop: "latency",
      get name() { return tViews('circuit.ctLatency'); } ,
      size: 127
    },
    {
      prop: "jitter",
      get name() { return tViews('circuit.ctJitter'); } ,
      size: 108
    },

    {
      prop: "vdevice_id",
      get name() { return tViews('circuit.ctLocalDevice'); } ,
      size: 130
    },
  ];
  for (const item of tableColumns)
    Object.assign(item, { id: item.prop, sortable: true });
  return tableColumns;
};

// Report : Link Utilization  - Circuits Table columns config

export const getReportTableColumnsLinkUtilization = () => {
  const tableColumns = [
    {
      prop: "circuit_display_name",
      get name() { return tViews('circuit.ctName'); } ,
      size: 200
    },
    {
      prop: "service_provider",
      get name() { return tViews('circuit.ctProvider'); } ,
      size: 200
    },
    {
      prop: "site_name",
      get name() { return tViews('circuit.ctSitesName'); } ,
      size: 150
    },
    {
      prop: "site_location",
      get name() { return tViews('circuit.ctLocation'); } ,
      size: 150
    },
    {
      prop: "display_total_bps",
      get name() { return tViews('circuit.ctRxTx'); } ,
      size: 91
    },
    {
      prop: "display_rx_bps",
      get name() { return tViews('circuit.ctRx'); } ,
      order: "asc",
      size: 90
    },
    {
      prop: "display_tx_bps",
      get name() { return tViews('circuit.ctTx'); } ,
      size: 90
    },
    {
      prop: "vdevice_id",
      get name() { return tViews('circuit.ctLocalDevice'); } ,
      size: 120
    },
  ];
  for (const item of tableColumns)
    Object.assign(item, { id: item.prop, sortable: true });
  return tableColumns;
};

// Report : Link Utilization(RX and TX Utilization)  - Circuits Table columns config

export const getReportTableLinkUtilizationBandwidth = () => {
  const tableColumns = [
    {
      prop: "circuit_display_name",
      get name() { return tViews('circuit.ctName'); } ,
      size: 200
    },
    {
      prop: "service_provider",
      get name() { return tViews('circuit.ctProvider'); } ,
      size: 200
    },
    {
      prop: "site_name",
      get name() { return tViews('circuit.ctSitesName'); } ,
      size: 140
    },
    {
      prop: "site_location",
      get name() { return tViews('circuit.ctLocation'); } ,
      size: 140
    },
    {
      prop: "display_total_bps",
      get name() { return tViews('circuit.ctRxTx'); } ,
      size: 91
    },
    {
      prop: "display_rx_bps",
      get name() { return tViews('circuit.ctRx'); } ,
      order: "asc",
      size: 90
    },
    {
      prop: "display_tx_bps",
      get name() { return tViews('circuit.ctTx'); } ,
      size: 90
    },
    {
      prop: "rx_utilization",
      get name() { return tViews('circuit.ctRxUtilReport'); } ,
      size: 120
    },
    {
      prop: "tx_utilization",
      get name() { return tViews('circuit.ctTxUtilReport'); } ,
      size: 120
    },
    {
      prop: "vdevice_id",
      get name() { return tViews('circuit.ctLocalDevice'); } ,
      size: 120
    },
  ];
  for (const item of tableColumns)
    Object.assign(item, { id: item.prop, sortable: true });
  return tableColumns;
};

// Report : Link Availability  - Circuits Table columns config
export const getReportTableLinkAvailabitlity = () => {
  const tableColumns = [
    {
      prop: "circuit_display_name",
      get name() { return tViews('circuit.ctName'); } ,
      size: 280
    },
    {
      prop: "service_provider",
      get name() { return tViews('circuit.ctProvider'); } ,
      size: 280
    },
    {
      prop: "site_name",
      get name() { return tViews('circuit.ctSitesName'); } ,
      size: 140
    },
    {
      prop: "availability",
      get name() { return tViews('circuit.ctAvail'); } ,
      size: 132
    },
    {
      prop: "downtime",
      get name() { return tViews('circuit.ctDowntime'); } ,
      size: 107
    },
    {
      prop: "vdevice_id",
      get name() { return tViews('circuit.ctLocalDevice'); } ,
      size: 120
    },
    {
      prop: "color",
      get name() { return tViews('circuit.ctLocalColor'); } ,
      size: 120
    },
  ];
  for (const item of tableColumns)
    Object.assign(item, { id: item.prop, sortable: true });
  return tableColumns;
};


const validateAndFormatNumber = value => {
  if (Number.isFinite(value)) return `${parseFloat(value.toFixed(2))}%`;
  return defaultCellValue;
};

export const setCircuitsTableData = data => {
  for (const item of data) {
    item.id = item.circuit_display_name.replace(":", "_");
    item.availability = validateAndFormatNumber(item.availability);
    item.downtime = convertTimetoUnit(item.downtime);
    item.rx_utilization = validateAndFormatNumber(item.rx_utilization);
    item.tx_utilization = validateAndFormatNumber(item.tx_utilization);
  }
  return data;
};
